module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "180px"
    }
  }, [_c('p', [_vm._v("“We are tied together in a single garment of destiny. We are caught in a network of mutuality, And I can never be who I ought to be until you are who you ought to be.”")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("John Paul Sartre, "), _c('em', [_vm._v("THE EXIT")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("“Do we in our time have an answer to the question of what we really mean by the word ‘being’?”")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Martin Heidegger, "), _c('em', [_vm._v("BEING AND TIME")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("“The mission of Israel is to prepare humanity for the rule of God.”")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Martin Buber, "), _c('em', [_vm._v("THE PROPHETIC FAITH")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("“I came to cast fire upon the earth; and would that it were already kindled!”")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Jesus of Nazareth, LUKE 12:49")])]), _vm._v(" "), _c('p', [_c('em', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 72
// module chunks = 0